export enum otpType {
    email = 'Email',
    sms = 'SMS',
    phone = 'Phone',
    voiceSignature = 'Voice Signature',
}